export default __webpack_public_path__ + "static/media/spinner.6f5881ca.svg";